<template>
    <div>
        <div class="panel-group" id="accordion">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title" style="font-weight:bold;">
                        {{shop.shopName}}
                    </h4>
                    <div style="white-space:pre-line;padding:5px;">
                        {{shop.intro}}
                    </div>
                </div>

                <div class="panel-collapse collapse in">
                    <div class="panel-body">

                        <div v-if="infoLabels!==null">
                            <div v-for="mainCat in infoLabels">
                                <div style="font-weight:bold;">{{mainCat.category.name}}</div>
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="item in mainCat.items">
                                        <ul class="list-group">
                                            <div style="font-weight:bold;">{{item.category.name}}</div>
                                            <li style="padding:5px;list-style:none;" class="list-group-item-hidden" v-for="subItem in item.items">{{subItem.label}}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        props: ["shopInfo"],
        data: function () {
            return {
                infoLabels: [],
                images: [],
                shop: {}
            }
        },
        mounted: function () {
            this.shop = this.shopInfo.shop;
            this.infoLabels = this.shop.infoLabels;
            this.images = this.shopInfo.shop.images;
        }
    }
</script>